<template>
  <div class="app-infobox" :class="colour" v-if="isActive">
    <SimonModal
      :is-visible="showInfoModal"
      @hide="showInfoModal = false"
    >
      <div v-html="txtInfoModal"></div>
    </SimonModal>
    <div class="box--info">
      <div v-html="processHTML(txtDescription)"></div>
    </div>
    <button v-if="hasInfoIcon" @click="openInfoModal()" :aria-label="lblInfoIcon" class="icon-only" type="button"><img height="22" width="22" :src="colour === 'fill-white' ? 'files/flash/images/svg-icons/info-icon.svg' : 'files/flash/images/svg-icons/info-icon-white.svg'"></button>
  </div>
</template>
<script>

import trackingHandler from '@/mixins/trackingHandler'
import SimonModal from '@/components/modal/SimonModal.vue'
import date from '@/mixins/validators/date'
export default {
  name: 'TariffInfoBox',
  components: {
    SimonModal
  },
  mixins: [
    trackingHandler,
    date
  ],
  props: {
    colour: {
      type: String,
      default: ''
    },
    txtDescription: {
      type: String,
      default: ''
    },
    hasInfoIcon: {
      type: String,
      default: ''
    },
    lblInfoIcon: {
      type: String,
      default: ''
    },
    txtInfoModal: {
      type: String,
      default: ''
    },
    startDate: {
      type: [Number, String],
      default: 0
    },
    endDate: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      loading: false,
      showInfoModal: false
    }
  },
  computed: {
    isActive () {
      return this.todayIsBetweenDates(this.startDate, this.endDate)
    }
  },
  methods: {
    openInfoModal (token = this.getSlotText('voucherCode')) {
      this.showInfoModal = true
      this.trackData('information', {
        information_action: 'reveal',
        information_name: token.toLowerCase() + ' info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      })
    }
  }
}
</script>
